import type { ExpanderListItem } from '@rio-cloud/rio-uikit/ExpanderList';
import Notification from '@rio-cloud/rio-uikit/Notification';
import type { IntlShape } from 'react-intl';

export const handleNotificationForUpdateData = (intl: IntlShape) => {
    Notification.info(
        intl.formatMessage({
            id: 'intl-msg:ordercom-cloud-frontend.notification.data.update.success',
            defaultMessage: 'Your data has been updated',
        })
    );
};

export type ExpanderListItemBase = Omit<ExpanderListItem, 'onOpen' | 'onClose' | 'open' | 'className'>;

export type Override<Type, NewType> = Omit<Type, keyof NewType> & NewType;
